<template>
    <div class="unit-list">
        <!-- 头部 -->
        <div class="unit-list-header">
            <!-- <SearchControl :searchWidth="388" placeholder="输入关键词查找" @searchAction="searchAction"></SearchControl> -->
            <DownloadExcel
                :data="selectedUnitArray"
                :export-fields="fieldsObj"
                name="施工队.xls"
            >
                <button :class="{ disabled: !selectedUnitArray || selectedUnitArray.length == 0 }">导出</button>
            </DownloadExcel>
        </div>
        <!-- 列表 -->
        <div class="unit-table-list gq-table">
            <el-table
                ref="multipleTable"
                :data="tableData"
                tooltip-effect="dark"
                style="width: 100%"
                :border="true"
                :row-key="getRowKey"
                @selection-change="handleSelectionChange"
            >
                <el-table-column
                    type="selection"
                    width="42"
                    fixed="left"
                    :reserve-selection="true"
                >
                </el-table-column>
                <!-- 施工队 -->
                <el-table-column
                    label="施工队"
                    min-width="20%"
                >
                    <template slot-scope="scope">
                        <el-tooltip popper-class="tool-tip-class" placement="bottom-start" effect="light" :visible-arrow="false">
                            <div slot="content">{{ scope.row.deptName }}</div>
                            <span class="single-show">{{ scope.row.deptName }}</span>
                        </el-tooltip>
                    </template>
                </el-table-column>
                <!-- 施工队(账号) -->
                <!-- <el-table-column
                    label="施工队(账号)"
                    min-width="8%"
                >
                    <template slot-scope="scope">
                        <el-tooltip popper-class="tool-tip-class" placement="bottom-start" effect="light" :visible-arrow="false">
                            <div slot="content">{{ scope.row.mobile }}</div>
                            <span class="single-show">{{ scope.row.mobile }}</span>
                        </el-tooltip>
                    </template>
                </el-table-column> -->
                <!-- 负责人 -->
                <el-table-column
                    label="负责人"
                    min-width="10%"
                >
                    <template slot-scope="scope">
                        <el-tooltip popper-class="tool-tip-class" placement="bottom-start" effect="light" :visible-arrow="false">
                            <div slot="content">{{ scope.row.username }}</div>
                            <span class="single-show">{{ scope.row.username }}</span>
                        </el-tooltip>
                    </template>
                </el-table-column>
                <!-- 联系方式 -->
                <el-table-column
                    label="联系方式"
                    min-width="10%"
                >
                    <template slot-scope="scope">
                        <el-tooltip popper-class="tool-tip-class" placement="bottom-start" effect="light" :visible-arrow="false">
                            <div slot="content">{{ scope.row.mobile }}</div>
                            <span class="single-show">{{ scope.row.mobile }}</span>
                        </el-tooltip>
                    </template>
                </el-table-column>
                <!-- 钻探任务数量 -->
                <el-table-column
                    label="钻探任务数量"
                    min-width="10%"
                >
                    <template slot-scope="scope">
                        <el-tooltip popper-class="tool-tip-class" placement="bottom-start" effect="light" :visible-arrow="false">
                            <div slot="content">{{ scope.row.zkCount }}</div>
                            <span class="single-show">{{ scope.row.zkCount }}</span>
                        </el-tooltip>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <!-- 分页 -->
        <div class="pagination">
            <PaginationView :currentPage="pageNumber" :total="total"></PaginationView>
        </div>
    </div>
</template>
<script>
// import SearchControl from '../../../../components/SearchControl.vue';
import PaginationView from '../../../../components/PaginationView.vue';
import { GetUnitList } from '@/http/api/api-hb'
export default {
    components: { PaginationView },
    props: {
        unitObj: {
            type: Object,
        }
    },
    data() {
        return {
            // 所有施工队
            teamList: [],
            // 施工队列表
            tableData: [],
            // 选中的施工队列表
            selectedUnitArray: [],
            fieldsObj: {
                '施工队': 'deptName',
                '负责人': 'username',
                '联系方式': 'mobile',
                '钻探任务数量': 'zkCount'
            },
            pageNumber: 1,
            pageSize: 10,
            total: 0
        }
    },
    watch: {
        unitObj: {
            handler() {
                this.pageNumber = 1
                this.requestConsTeamList()
            },
            depp: true
        }
    },
    mounted() {
        this.requestConsTeamList()
    },
    methods: {
        // 获取施工队列表
        requestConsTeamList() {
            GetUnitList({ pid: this.unitObj.id, }).then(res => {
                if (res.code == 200) {
                    this.teamList = res.data
                    this.total = this.teamList.length
                    this.setPageData()
                } else {
                    this.$message.warning(res.msg)
                }
            })
        },
        // 假分页
        setPageData() {
            this.tableData = []
            for (let index = 0; index < this.teamList.length; index++) {
                const element = this.teamList[index];
                if (index < this.pageNumber * this.pageSize && index >= (this.pageNumber-1) * this.pageSize) {
                    this.tableData.push(element)
                }
            }
        },
        // 搜索
        searchAction() {

        },
        // 分页进入到某一页
        paginationRequestPage(page) {
            this.pageNumber = page
            this.setPageData()
        },
        // 选择了某一项
        handleSelectionChange(selection) {
            this.selectedUnitArray = selection
        },
        getRowKey(row) {
            return row.id + ''
        }
    },
}
</script>
<style src="../../../../assets/css/gq_table.css" scoped></style>
<style scoped>
    .unit-list {
        width: 100%;
        height: 100%;
        background-color: #fff;
        border-radius: 6px;
    }
    /* 头部 */
    .unit-list .unit-list-header {
        width: calc(100% - 40px);
        height: 80px;
        padding: 0 20px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex-direction: row-reverse;
    }
    .unit-list .unit-list-header button {
        width: 120px;
        height: 40px;
        border-radius: 6px;
        font-size: 16px;
        font-weight: 500;
        line-height: 22px;
        color: #fff;
        background: #0054A0;
    }
    .unit-list .unit-list-header button.disabled {
        color: #CCCCCC;
        background: #F0F0F0;
    }
    /* 分页 */
    .unit-list .pagination {
        width: 100%;
        height: 48px;
    }
    /* 列表 */
    .unit-list .unit-table-list {
        width: calc(100% - 40px);
        height: calc(100% - 128px);
        padding: 0 20px;
    }
</style>